import { render, staticRenderFns } from "./HuayNumberGrid.vue?vue&type=template&id=c948b512&scoped=true&"
import script from "./HuayNumberGrid.vue?vue&type=script&lang=js&"
export * from "./HuayNumberGrid.vue?vue&type=script&lang=js&"
import style0 from "./HuayNumberGrid.vue?vue&type=style&index=0&id=c948b512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c948b512",
  null
  
)

export default component.exports